import { computed, type Ref } from 'vue'
import { useDisplay } from 'vuetify'
import { useStore } from 'vuex'

type UseNavigationDrawerReturn = {
  drawerWidths: Ref<{
    mini: number,
    unfolded: number,
    current: number,
    currentPx: string,
  }>
}

const MINI_WIDTH = 80

export function useNavigationDrawer (): UseNavigationDrawerReturn {
  const { mobile, width, xs } = useDisplay()
  const store = useStore();

  const unfoldedWidth = computed(() => {
    switch (true) {
      case xs.value: return Math.trunc(width.value * .8)
      case mobile.value: return Math.trunc(width.value * .33)
      default: return 200
    }
  })

  const current = computed(() => {
    if (mobile.value) {
      return 0
    }

    return store.state.global.mini
      ? MINI_WIDTH
      : unfoldedWidth.value
  })

  const drawerWidths = computed(() => ({
    mini: MINI_WIDTH,
    unfolded: unfoldedWidth.value,
    current: current.value,
    currentPx: `${current.value}px`,
  }))

  return { drawerWidths }
}
